/**
 * @deprecated Import `createSvgIcon` from `@mui/material/SvgIcon` instead.
 */
export { default } from "../SvgIcon/createSvgIcon.mjs";